module.exports = __webpack_public_path__ + "static/media/home.1961ea5c.svg";